import { navigate } from "gatsby";
import React, { useCallback } from "react";
import Button from '../../components/Button';
import Layout from "../../components/Layout";
import LogoAll from '../../components/LogoAll';
import SEO from "../../components/Seo";


const IndexPage = () => {
    const handleTurnOnButtonPress = useCallback(async () => {
        try {
            // await navigate('/denki/step2');
        } catch (error) {
            console.error(error);
        }
    }, []);

    const handleSwitchingButtonPress = useCallback(async () => {
        try {
            await navigate('/denki/step2');
        } catch (error) {
            console.error(error);
        }
    }, []);

    return (
        <Layout>
            <SEO title="PinTでんき申込み" />
            <LogoAll />
            <div
                style={{
                    textAlign: 'center',
                }}
            >
                <div>
                    <Button
                        label="引っ越し先の申込み(準備中)"
                        disable={true}
                        onClick={handleTurnOnButtonPress}
                    />
                </div>
                <div style={{ marginTop: 16 }}>
                    <Button
                        label="今のお部屋の申込み"
                        onClick={handleSwitchingButtonPress}
                    />
                </div>
            </div>
        </Layout>
    );
};

export default IndexPage;
